export default __webpack_public_path__ + "static/media/Smlouva a Všeobecné Obchodní Podmínky v platnosti od 21.4.2020 - Hostivice a Hostavice.5bf0c4dd.pdf";